import { ToTopOutlined } from "@ant-design/icons"
import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from "gatsby-source-contentful/rich-text"
import React, { useCallback, useEffect } from "react"
import { Link } from "react-scroll"
import styled, { css } from "styled-components"
import Breakpoints from "../../../components/shared/breakpoints"
import { Block } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import VariantContainer from "../../atoms/variant-container"
import ContentBlock from "../../molecules/content-block"

interface IArticleBody {
  body: RenderRichTextData<ContentfulRichTextGatsbyReference>
}

const ToTopButton = styled(Link)<{ $isVisible: boolean }>`
  display: none;
  @media (min-width: ${Breakpoints.lg}) {
    display: flex;
    z-index: 1;
    opacity: ${(props) => (props.$isVisible ? 1 : 0)};
    visibility: ${(props) => (props.$isVisible ? "visible" : "hidden")};
    justify-content: center;
    align-items: center;
    transform: translateX(-75%);
    height: 48px;
    width: 48px;
    position: fixed;
    bottom: 50%;
    cursor: pointer;
    background-color: var(--white);
    color: var(--slate);
    padding: 8px;
    border-radius: 4px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 24px;
    box-sizing: border-box;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }
`

/**
 * Template for RichText article body from Contentful
 * @param body - RichText data from Contentful
 */
const ArticleBody = ({ body }: IArticleBody) => {
  const [isButtonVisible, setButtonVisible] = React.useState(false)
  const buttonVisibleY = 1000

  // Scroll listener to show/hide floating button
  const onScroll = useCallback(() => {
    if (window.scrollY > buttonVisibleY) {
      setButtonVisible(true)
    } else {
      setButtonVisible(false)
    }
  }, [setButtonVisible])

  useEffect(() => {
    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  return (
    <BlogGrid>
      <VariantContainer
        variants={[
          css`
            grid-column: -2;
          `,
        ]}
      >
        <ToTopButton
          to="nav-header"
          smooth={true}
          duration={1000}
          $isVisible={isButtonVisible}
        >
          <ToTopOutlined />
        </ToTopButton>
      </VariantContainer>
      <Block col={{ lg: "3/-3" }}>
        <ContentBlock.BlogRichText>{body}</ContentBlock.BlogRichText>
      </Block>
    </BlogGrid>
  )
}

export default ArticleBody
